import Swal from 'sweetalert2'

export async function useMaterialTypeWarning({ returnResult = false } = {}) {
	const result = await Swal.fire({
		icon: 'warning',
		title: 'DESEJA SALVAR AS ALTERAÇÕES?',
		text: 'A ALTERAÇÃO DO TIPO DE MATERIAL PODE GERAR INCONSISTÊNCIA COM O CÓDIGO DO MATERIAL.',
		input: 'checkbox',
		inputValue: 0,
		inputValidator: value =>
			!value && 'É NECESSÁRIO CONFIRMAR PARA PROSSEGUIR.',
		showDenyButton: true,
		reverseButtons: true,
		confirmButtonText: 'SIM',
		denyButtonText: 'NÃO',
		didOpen: () => {
			Swal.getConfirmButton().disabled = true
			Swal.getInput().addEventListener('change', event => {
				Swal.getConfirmButton().disabled = !event.target.checked
			})
		},
		customClass: {
			container: 'themed',
		},
	})
	return returnResult ? result : result.isConfirmed
}
